import { useState, useRef } from 'react';
import DigitalTwinRepository from '@/domain/DigitalTwin/DigitalTwinRepository';
import { ResumeDigitalTwin } from '@/domain/DigitalTwin/DigitalTwin';

export const useDigitalTwins = () => {
	const [digitalTwinsData, setDigitalTwinsData] = useState<ResumeDigitalTwin[] | null>(null);
	const [loading, setLoading] = useState(false);
	const cachedLocationId = useRef<string | null>(null);
	const digitalTwinRepository = useRef(new DigitalTwinRepository());

	const fetchDigitalTwinsData = async (locationId: string) => {
		setLoading(true);
		try {
			const locationIdAsNumber = parseInt(locationId, 10);
			if (!isNaN(locationIdAsNumber)) {
				const data = await digitalTwinRepository.current.getDigitalTwinsResume({
					locationId: locationIdAsNumber
				});
				setDigitalTwinsData(data);
				cachedLocationId.current = locationId;
			}
		} catch (error) {
			console.error('Error fetching digital twins data:', error);
			setDigitalTwinsData(null);
		} finally {
			setLoading(false);
		}
	};

	const clearData = () => {
		setDigitalTwinsData(null);
		cachedLocationId.current = null;
	};

	return {
		digitalTwinsData,
		loading,
		fetchDigitalTwinsData,
		clearData,
		cachedLocationId: cachedLocationId.current
	};
};